import { SafeTag } from '@itau-loans-www/components'

import SummaryLayout from '../layouts/Summary'
import './allow-fgts-app.scss'
import AuthorizeFgtsSection from './components/AuthorizeFgtsSection'

const AllowFGTSApp = () => {
  return (
    <SummaryLayout className="allow-app-fgts">
      <div className="container allow-app-fgts__content">
        <SafeTag />
        <div className="allow-app-fgts__texts">
          <h1 className="allow-app-fgts__hero">
            Quase lá, mas antes precisamos identificar se você tem o Saque
            Aniversário disponível ...
          </h1>
          <p className="allow-app-fgts__subtitle">Passo a passo</p>
          <h2 className="allow-app-fgts__title">
            Confira como aderir ao saque aniversário
          </h2>
        </div>
        <AuthorizeFgtsSection />
      </div>
    </SummaryLayout>
  )
}

export default AllowFGTSApp
